'use strict';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import sxQuery from '../../sxQuery/sxQuery';
import StringHelper from '../../global/StringHelper';
import Helper from '../utils/Helper';
import Logger from '../../global/Logger';
import UiHelper from '../ui/UiHelper';
import Polyfill from '../polyfills/Polyfill';
import Icons from './Icons';
import FilterPosition from '../enums/FilterPosition';
import FilterGroupBuilder from './FilterGroupBuilder';
import FilterType from '../enums/FilterType';
import DatePrecision from '../enums/DatePrecision';
import SxQueryUtils from '../../sxQuery/SxQueryUtils';
import MediaQueryMatchType from '../../sxQuery/MediaQueryMatchType';
var persistentFilterOptions = {
    // collapsedFilterGroups: [],
    ss360AreMobileSuggestsOpen: false
};
var Filter = /** @class */ (function () {
    function Filter(context, filterGroups, activeOptions, query, onChange, filterIdToName, totalResults, filterMapping, fallbackNames, optionViewNames, activeGuidedQuestions) {
        var _this = this;
        if (fallbackNames === void 0) { fallbackNames = {}; }
        if (optionViewNames === void 0) { optionViewNames = {}; }
        if (activeGuidedQuestions === void 0) { activeGuidedQuestions = []; }
        this.context = context;
        this.filterConfig = context.pluginConfiguration.filters;
        this.filterGroups = filterGroups;
        this.position = this.filterConfig.position;
        this.query = query;
        this.onChange = onChange;
        this.totalResults = totalResults;
        this.filterModificationMap = {};
        this.filters = [];
        this.units = {};
        this.hasOptions = false;
        this.filterDeletionValueMap = {};
        this.isSimpleValueFormat = true;
        this.groupCache = context.getFilterViewGroupCache();
        var groupCache = this.groupCache;
        this.previousFilterGroups = Object.keys(groupCache.groupByKey);
        this.sortingSelection = context.getExistingSorting();
        this.fallbackNames = fallbackNames;
        this.optionViewNames = optionViewNames;
        this.activeGuidedQuestions = activeGuidedQuestions || [];
        this.appendStyles();
        this.ensureFilterLayer();
        this.createKeyToNameMapping(filterIdToName);
        var onExpand = function () {
            _this.expandHandler();
        };
        var onChangeHandler = function (key, value, label) {
            _this.changeHandler(key || label, value);
        };
        this.builder = new FilterGroupBuilder(context, onExpand, onChangeHandler, persistentFilterOptions, groupCache);
        Object.values(groupCache.viewGroupByKey).forEach(function (viewGroup) {
            viewGroup.updateHandlers(onChangeHandler, onExpand);
        });
        // array to map
        this.activeFilter = (activeOptions || []).reduce(function (acc, obj) {
            var key = Object.keys(obj)[0];
            acc[key] = obj[key];
            return acc;
        }, {});
        this.activeOptions = activeOptions;
        this.initExpandedGroups();
        this.renderFilters();
        this.previousFilterGroups.forEach(function (groupKey) {
            if (groupCache.groupByKey[groupKey] !== undefined) {
                groupCache.groupByKey[groupKey].wrapper.remove();
            }
            delete groupCache.groupByKey[groupKey];
            delete groupCache.viewGroupByKey[groupKey];
        });
        var positionIncrement = this.filterLayer.findChildren('*:not(.ss360-filter__group)').length;
        var positionDecrement = 0;
        for (var i = 0; i < (this.filterConfig.limit || 9999) && i < this.filterGroups.length; i++) {
            var key = this.filterGroups[i].key;
            var filterViewGroup = this.groupCache.viewGroupByKey[key];
            if (filterViewGroup === undefined) {
                positionDecrement++;
                continue;
            }
            this.filterLayer.ensureChildPosition(filterViewGroup.getWrapper().get(0), i + positionIncrement - positionDecrement);
        }
        this.renderMobileToggle();
        this.mount();
        this.renderDeleteBar();
        groupCache.filters = this.filters;
        Polyfill.focusWithin('.ss360-slider', 'ss360-slider--focus-within');
        this.bindMappings(filterMapping);
        var filterRenderedCallback = context.pluginConfiguration.callbacks.filterRendered;
        if (filterRenderedCallback !== undefined && (typeof filterRenderedCallback) === 'function') {
            filterRenderedCallback();
        }
        setTimeout(function () {
            _this.context.getExistingLayer().find('.ss360-filter__group').addClass('ss360-filter__group--mounted');
        }, 0);
        if (groupCache.lastInteractedGroupKey !== undefined && groupCache.lastInteractedGroupOffsetTop !== undefined) {
            var isSlideIn = this.isSlideIn();
            sxQuery(isSlideIn ? this.filterLayer : window).off('scroll.filterJump');
            var $node = sxQuery("#ss360-filter-".concat(StringHelper.getSafeKey(groupCache.lastInteractedGroupKey), " .ss360-filter__button"));
            var offsetTop = isSlideIn ? this.filterLayer.offset().top : sxQuery(window).scrollTop();
            var scrollTop = $node.offset().top - offsetTop;
            var diff = scrollTop - groupCache.lastInteractedGroupOffsetTop;
            if (isSlideIn) {
                this.filterLayer.scrollTopBy(diff);
            }
            else if (this.filterConfig.position !== FilterPosition.Top) {
                sxQuery(window).scrollTopBy(diff);
            }
        }
    }
    Filter.prototype.isSlideIn = function () {
        return SxQueryUtils.matchesMediaQuery(MediaQueryMatchType.Max, 991) || this.filterConfig.forceSlideIn;
    };
    Filter.prototype.appendStyles = function () {
        if (this.context.pluginConfiguration.style.defaultCss) {
            var $head = sxQuery('head');
            sxQuery('#ss360-filter-css').remove();
            // eslint-disable-next-line
            var css = require('../../../sass/siteSearch/filters.scss');
            $head.append("<style id=\"ss360-filter-css\" type=\"text/css\">".concat(css, "</style>"));
        }
    };
    Filter.prototype.initExpandedGroups = function () {
        if (!('collapsedFilterGroups' in persistentFilterOptions)) {
            var filterConfig = this.filterConfig;
            persistentFilterOptions.collapsedFilterGroups = [];
            if (filterConfig.expandedGroupsCount !== undefined && filterConfig.expandedGroupsCount !== -1 && filterConfig.expandedGroupsCount !== -1) {
                // @ts-ignore
                var expandedGroupsCount = parseInt(filterConfig.expandedGroupsCount, 10);
                for (var i = expandedGroupsCount; i < this.filterGroups.length; i++) {
                    var group = this.filterGroups[i];
                    if (this.activeFilter[group.key] === undefined) {
                        persistentFilterOptions.collapsedFilterGroups.push(group.key);
                    }
                }
            }
        }
    };
    Filter.prototype.ensureFilterLayer = function () {
        var groupCache = this.groupCache;
        var filterLayer = groupCache.layer;
        if (filterLayer !== undefined && !filterLayer.isMounted()) { // new instance, js navigation
            filterLayer = undefined;
            groupCache.groupByKey = {};
            groupCache.activeGroups = [];
            groupCache.layer = undefined;
            groupCache.searchQueries = {};
            groupCache.expandedGroups = {};
        }
        var filterConfig = this.filterConfig;
        if (filterLayer === undefined) {
            filterLayer = sxQuery("<section id=\"".concat(this.context.filterLayerId, "\" class=\"ss360-n-section ss360-flex ss360-flex--wrap ss360-filter\" role=\"search\" aria-label=\"").concat(filterConfig.label, "\"></section>"));
        }
        filterLayer.addClass('ss360-filter--mounting');
        groupCache.layer = filterLayer;
        this.filterLayer = filterLayer;
        if (this.position === FilterPosition.Left) {
            var hl = filterConfig.headingLevel;
            if (filterLayer.find('#ss360CloseFilterButton').length === 0) {
                filterLayer.append(UiHelper.createCloseLayerButton('ss360CloseFilterButton', 'Close Filter'));
            }
            if (filterLayer.find('.ss360-filter__heading').length === 0) {
                filterLayer.append("<h".concat(hl, " class=\"ss360-filter__heading\">").concat(filterConfig.label, "</h").concat(hl, ">"));
            }
        }
    };
    Filter.prototype.createKeyToNameMapping = function (filterIdToName) {
        var _this = this;
        this.keyToName = this.filterGroups.reduce(function (acc, filterGroup) {
            acc[filterGroup.key] = filterGroup.name;
            return acc;
        }, {});
        if (this.context.pluginConfiguration.results.nameParsing && filterIdToName !== undefined) {
            Object.keys(filterIdToName).forEach(function (filterId) {
                if (_this.keyToName[filterId] === undefined) {
                    _this.keyToName[filterId] = filterIdToName[filterId];
                }
            });
        }
    };
    Filter.prototype.changeHandler = function (id, val) {
        var _this = this;
        var groupCache = this.groupCache;
        var key = id;
        this.activeFilter[key] = val;
        groupCache.lastInteractedGroupKey = key;
        var $node = sxQuery("#ss360-filter-".concat(StringHelper.getSafeKey(groupCache.lastInteractedGroupKey), " .ss360-filter__button"));
        var isSlideIn = this.isSlideIn();
        var updateOffsetTop = function () {
            var offsetTop = isSlideIn ? _this.filterLayer.offset().top : sxQuery(window).scrollTop();
            groupCache.lastInteractedGroupOffsetTop = $node.offset().top - offsetTop;
        };
        updateOffsetTop();
        var isUpdating = false;
        sxQuery(isSlideIn ? this.filterLayer : window).off('scroll.filterJump').on('scroll.filterJump', function () {
            if (isUpdating)
                return;
            isUpdating = true;
            setTimeout(function () {
                updateOffsetTop();
                isUpdating = false;
            }, 5);
        });
        var allowFalse = false;
        if (val === false) {
            var filterGroup = this.filterGroups.filter(function (group) { return group.key === id; })[0];
            if (filterGroup !== undefined) {
                allowFalse = (filterGroup.values || []).length > 1;
            }
        }
        // @ts-ignore
        if (val === undefined || (val === false && !allowFalse) || (val !== true && val.length === 0 && !('min' in val))) {
            delete this.activeFilter[key];
        }
        if (this.context.hasInsights()) {
            var data = "".concat(key, "<#>").concat(this.keyToName[key], "=>").concat(this.activeFilter[key] !== undefined ? JSON.stringify(this.activeFilter[key]) : '--');
            this.context.getInsights().trackFilterInteraction(this.query, groupCache.layer.get()[0], data);
        }
        if (this.onChange === undefined || typeof this.onChange !== 'function') {
            return;
        }
        Object.keys(this.activeFilter).forEach(function (otherKey) {
            if (_this.filterModificationMap[otherKey] !== undefined) { // TODO: fix this shit, clean it up, arrrgh
                // @ts-ignore
                _this.activeFilter[otherKey] = _this.activeFilter[otherKey].map(function (otherVal) { return _this.filterModificationMap[otherKey][otherVal] || otherVal; });
            }
        });
        this.onChange(this.activeFilter, this.activeGuidedQuestions);
        sxQuery(window).off("resize.".concat(this.context.generateId('ss360FilterResize')));
    };
    Filter.prototype.getSetting = function (filterGroup) {
        return this.filterConfig.settings[filterGroup.name] || this.filterConfig.settings[filterGroup.key] || {};
    };
    Filter.prototype.expandHandler = function () {
        Object.values(this.groupCache.viewGroupByKey).forEach(function (filter) { return filter.mount(); });
    };
    Filter.prototype.renderRangeFilter = function (filterGroup, settings, viewLabel) {
        var groupCache = this.groupCache;
        var filterAdded = false;
        var activeFilter = this.activeFilter;
        var key = filterGroup.key;
        if (filterGroup.min !== filterGroup.max || activeFilter[key] !== undefined) {
            var isDate = filterGroup.filterType === 'DATE';
            var step = isDate && settings.step === undefined ? 24 * 60 * 60 : settings.step; // one day by default
            if (settings.unit === undefined && filterGroup.unit !== undefined) {
                this.units[key] = filterGroup.unit;
            }
            var group = this.builder.range(key, viewLabel, filterGroup.min, filterGroup.max, step, settings.unit || filterGroup.unit, 
            // @ts-ignore
            activeFilter[key], settings, filterGroup.counts, isDate, filterGroup.precision, filterGroup.fractionalDigits);
            this.filters.push(group);
            groupCache.viewGroupByKey[key] = group;
            filterAdded = true;
            this.hasOptions = true;
        }
        return filterAdded;
    };
    Filter.prototype.renderTreeFilter = function (filterGroup, viewLabel) {
        var groupCache = this.groupCache;
        var values = filterGroup.categories || [];
        var filterAdded = false;
        var key = filterGroup.key;
        var activeFilter = this.activeFilter;
        values = this.parseCategoryTreeValues(key, values);
        this.hasOptions = this.hasOptions || values.length > 0;
        // @ts-ignore
        var group = this.builder.categoryTree(key, viewLabel, values, activeFilter[key]);
        this.filters.push(group);
        groupCache.viewGroupByKey[key] = group;
        filterAdded = true;
        // TODO: does not fully work with semantic mode yet
        return filterAdded;
    };
    Filter.prototype.parseCategoryTreeValues = function (key, values) {
        var _this = this;
        var filterDeletionValueMap = this.filterDeletionValueMap;
        filterDeletionValueMap[key] = {};
        if (!this.context.pluginConfiguration.results.nameParsing) {
            return values;
        }
        var activeFilter = this.activeFilter;
        // @ts-ignore
        if ((activeFilter[key] || []).length > 0) {
            var flatValueMap_1 = {};
            var populateFlatValueMap_1 = function (arr) { return arr.forEach(function (entry) {
                flatValueMap_1[entry.value] = { name: entry.viewName || entry.name, value: entry.value || entry.key };
                if (entry.children.length !== undefined) {
                    populateFlatValueMap_1(entry.children);
                }
            }); };
            populateFlatValueMap_1(values);
            // @ts-ignore
            activeFilter[key] = activeFilter[key].map(function (val) { return flatValueMap_1[val] ? flatValueMap_1[val].value : val; });
            (this.activeOptions || []).forEach(function (obj, idx) {
                var objKey = Object.keys(obj)[0];
                if (objKey === key) {
                    var newObj = {};
                    // @ts-ignore
                    newObj[objKey] = obj[objKey].map(function (option) {
                        var valueEntry = flatValueMap_1[option];
                        var name = valueEntry ? valueEntry.name : option;
                        filterDeletionValueMap[key][name] = valueEntry ? valueEntry.value : option;
                        return name;
                    });
                    _this.activeOptions[idx] = newObj;
                }
            });
        }
        var replaceKeys = function (arr) { return arr.map(function (entry) {
            entry.conceptId = entry.name;
            if (entry.children !== undefined) {
                entry.children = replaceKeys(entry.children);
            }
            return entry;
        }); };
        return replaceKeys(values);
    };
    /**
     * Unify filter group value format
     *
     * @param filterGroup FilterGroup
     */
    Filter.prototype.transformMultiselectValues = function (filterGroup) {
        var _this = this;
        var activeFilter = this.activeFilter;
        var key = filterGroup.key;
        // @ts-ignore
        filterGroup.values = filterGroup.values.filter(function (value) { return value !== null && value !== undefined; });
        if (filterGroup.values.length > 0 && (typeof filterGroup.values[0] === 'string')) {
            // @ts-ignore
            filterGroup.values = filterGroup.values.map(function (value) { return ({ key: value, name: value }); });
        }
        else {
            this.isSimpleValueFormat = false;
            if (this.context.pluginConfiguration.results.nameParsing) {
                // @ts-ignore
                var keyValueMap_1 = filterGroup.values.reduce(function (acc, value) {
                    if (value.value !== undefined) {
                        acc[value.value] = value.name;
                    }
                    else if (value.key !== undefined) {
                        acc[value.key] = value.name;
                    }
                    else {
                        acc[value.name] = value.name;
                    }
                    return acc;
                }, {});
                // @ts-ignore
                filterGroup.values = filterGroup.values.map(function (value) { return (__assign(__assign({}, value), { key: value.name, name: value.name })); });
                if (activeFilter[key] !== undefined) {
                    // @ts-ignore
                    activeFilter[key] = activeFilter[key] === true ? true : activeFilter[key].map(function (o) { return keyValueMap_1[o]; });
                }
                if (filterGroup.counts !== undefined) {
                    filterGroup.counts = Object.keys(filterGroup.counts).reduce(function (acc, countKey) {
                        var countName = keyValueMap_1[countKey];
                        acc[countName] = filterGroup.counts[countKey];
                        return acc;
                    }, {});
                }
                (this.activeOptions || []).forEach(function (obj, idx) {
                    var filterModificationMap = _this.filterModificationMap;
                    var objKey = Object.keys(obj)[0];
                    if (objKey === key) {
                        var newObj = {};
                        if (filterModificationMap[objKey] === undefined) {
                            filterModificationMap[objKey] = {};
                        }
                        if (obj[objKey] === true) {
                            newObj[objKey] = true;
                        }
                        else {
                            // @ts-ignore
                            newObj[objKey] = obj[objKey].map(function (option) {
                                // @ts-ignore
                                if (keyValueMap_1[option] !== undefined && keyValueMap_1[option] !== option) {
                                    // @ts-ignore
                                    filterModificationMap[objKey][keyValueMap_1[option]] = option;
                                }
                                // @ts-ignore
                                return keyValueMap_1[option];
                            });
                        }
                        _this.activeOptions[idx] = newObj;
                    }
                });
            }
        }
        // @ts-ignore
        filterGroup.values = filterGroup.values.filter(function (value) { return value.key !== undefined && value.key !== null && value.name !== null && value.name !== undefined; });
    };
    Filter.prototype.renderMultiselectFilter = function (filterGroup, filterSettings, viewLabel) {
        var groupCache = this.groupCache;
        if (filterGroup.values.length !== 0) {
            var showOnSingleResult = this.context.pluginConfiguration.filters.showOnSingleResult;
            var activeFilter = this.activeFilter;
            var key = filterGroup.key;
            // @ts-ignore
            if ((showOnSingleResult || filterGroup.type === FilterType.Boolean)
                || !(filterGroup.values.length === 1 && (filterGroup.counts || {})[filterGroup.values[0].key] === this.totalResults && activeFilter[filterGroup.key] === undefined)) { // don't show this group, if there is only one option which is available for all results
                this.hasOptions = true;
                if (filterGroup.type !== FilterType.Color || filterSettings.disableTiles) {
                    // @ts-ignore
                    var group = this.builder.multipleChoice(key, viewLabel, filterGroup.values, activeFilter[key], filterGroup.counts || {}, filterGroup.type === FilterType.Color, this.filterModificationMap[key], filterGroup.type === FilterType.Boolean, filterSettings.disableSearch === true);
                    this.filters.push(group);
                    groupCache.viewGroupByKey[key] = group;
                }
                else {
                    // @ts-ignore
                    var group = this.builder.color(key, viewLabel, filterGroup.values, activeFilter[key], filterGroup.counts || {}, this.filterModificationMap[key]);
                    this.filters.push(group);
                    groupCache.viewGroupByKey[key] = group;
                }
                return true;
            }
        }
        return false;
    };
    Filter.prototype.renderFilters = function () {
        var groupCache = this.groupCache;
        var wasNewFilterAdded = false;
        var filterConfig = this.context.pluginConfiguration.filters;
        for (var i = 0; i < (filterConfig.limit || 9999) && i < this.filterGroups.length; i++) {
            try {
                var filterGroup = this.filterGroups[i];
                var singleFilterConfig = this.getSetting(filterGroup);
                var viewLabel = filterGroup.name;
                if (singleFilterConfig.label !== undefined) {
                    viewLabel = singleFilterConfig.label;
                }
                var key = filterGroup.key;
                var filterViewGroup = groupCache.viewGroupByKey[key];
                if (filterViewGroup !== undefined && !filterViewGroup.getWrapper().isMounted()) {
                    filterViewGroup = undefined;
                }
                var filterAdded = false;
                var result = false;
                if ('min' in filterGroup) {
                    result = filterViewGroup !== undefined ? filterViewGroup.update(filterGroup, this.activeFilter[key]) : this.renderRangeFilter(filterGroup, singleFilterConfig, viewLabel);
                    filterAdded = result;
                }
                else if (filterGroup.type === FilterType.CategoryTree || filterGroup.filterType === FilterType.CategoryTree || filterGroup.type === FilterType.Tree || filterGroup.filterType === FilterType.Tree) {
                    var values = filterGroup.categories || [];
                    if (filterViewGroup !== undefined) {
                        values = this.parseCategoryTreeValues(key, values);
                    }
                    result = filterViewGroup !== undefined ? filterViewGroup.update(filterGroup, this.activeFilter[key], values) : this.renderTreeFilter(filterGroup, viewLabel);
                    filterAdded = result;
                }
                else {
                    if (filterGroup.type !== FilterType.Boolean) {
                        this.transformMultiselectValues(filterGroup);
                    }
                    result = filterViewGroup !== undefined ? filterViewGroup.update(filterGroup, this.activeFilter[key], this.filterModificationMap[key]) : this.renderMultiselectFilter(filterGroup, singleFilterConfig, viewLabel);
                    filterAdded = result;
                }
                if (filterAdded && filterGroup.visible === false) {
                    this.filters[this.filters.length - 1].addClass('ss360-filter__group--hidden');
                }
                var isLast = i === (filterConfig.limit || 9999) - 1 || i === this.filterGroups.length - 1;
                if (isLast && this.filters[this.filters.length - 1] !== undefined) {
                    this.filters[this.filters.length - 1].addClass('ss360-filter__group--last');
                }
                if (filterAdded && this.previousFilterGroups.indexOf(key) !== -1) {
                    this.previousFilterGroups.splice(this.previousFilterGroups.indexOf(key), 1);
                }
                else if (filterAdded) {
                    wasNewFilterAdded = true;
                }
            }
            catch (ex) {
                Logger.warn(ex);
            }
        }
        return wasNewFilterAdded;
    };
    Filter.prototype.renderMobileToggle = function () {
        var _this = this;
        var pluginConfig = this.context.pluginConfiguration;
        var filterConfig = this.filterConfig;
        var filterLayer = this.filterLayer;
        var showMobileButton = this.position === FilterPosition.Left ? this.context.getExistingLayer().find('.ss360-filter__mobile-toggle') : undefined;
        if (showMobileButton !== undefined && showMobileButton.length === 0) {
            var filterAriaLabel = filterConfig.toggleButtonLabel || 'Show Filter';
            showMobileButton = sxQuery("<button type=\"button\" class=\"ss360-filter__mobile-toggle ss360-n-button ss360-ac-b ss360-ac-c\">\n\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path fill=\"".concat(pluginConfig.style.accentColor, "\" d=\"M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z\"/></svg>\n\t\t\t</button>"));
            showMobileButton.attr('title', filterAriaLabel);
            showMobileButton.attr('aria-label', filterAriaLabel);
            if (filterConfig.toggleButtonLabel.length > 0) {
                showMobileButton.prepend("<strong>".concat(filterConfig.toggleButtonLabel, "</strong>"));
                showMobileButton.addClass('ss360-filter__mobile-toggle--labeled');
            }
        }
        var mobileBackdrop = this.position === FilterPosition.Left ? this.context.getExistingLayer().find('.ss360-filter__backdrop') : undefined;
        if (mobileBackdrop !== undefined && mobileBackdrop.length === 0) {
            mobileBackdrop = sxQuery('<div class="ss360-filter__backdrop" role="presentation"></div>');
        }
        var showMobile = function () {
            filterLayer.css('display', 'block');
            _this.expandHandler();
            sxQuery('body').addClass('ss360-u-hide-y-overflow');
            setTimeout(function () {
                filterLayer.addClass('ss360-filter--open');
                mobileBackdrop.addClass('ss360-filter__backdrop--open');
            }, 0);
            persistentFilterOptions.ss360AreMobileSuggestsOpen = true;
        };
        var hideMobile = function () {
            filterLayer.removeClass('ss360-filter--open');
            mobileBackdrop.removeClass('ss360-filter__backdrop--open');
            sxQuery('body').removeClass('ss360-u-hide-y-overflow');
            persistentFilterOptions.ss360AreMobileSuggestsOpen = false;
            setTimeout(function () {
                _this.filterLayer.css('display', null);
            }, 300);
        };
        if (persistentFilterOptions.ss360AreMobileSuggestsOpen === true) {
            filterLayer.css('transitionDuration', '0s');
            showMobile();
            setTimeout(function () {
                filterLayer.css('transitionDuration', null);
            }, 300);
        }
        if (this.position === FilterPosition.Left) {
            showMobileButton.off('click.mobileToggle').on('click.mobileToggle', showMobile);
            mobileBackdrop.off('click.mobileToggle').on('click.mobileToggle', function (e) {
                e.preventDefault();
                e.stopPropagation();
                hideMobile();
            });
            filterLayer.find('.ss360-close-button').off('click.mobileToggle').on('click.mobileToggle', function (e) {
                e.preventDefault();
                e.stopPropagation();
                setTimeout(function () {
                    hideMobile();
                }, 0);
            });
            var skipFilterButton = sxQuery("<button type=\"button\" class=\"ss360-skip-link ss360-n-button\">".concat(this.filterConfig.skipFilter, "</button>"));
            skipFilterButton.on('click', function () {
                _this.context.getExistingLayer().find('.ss360-suggests:first .ss360-suggests__link').focus();
            });
            filterLayer.find('.ss360-skip-link:not(.ss360-skip-link--group)').remove();
            filterLayer.prepend(skipFilterButton);
        }
        var firstGroup = sxQuery("#".concat(this.context.layerId, " .ss360-group, #").concat(this.context.noResultsLayerId));
        var sortingSelection = this.sortingSelection;
        // ensure positioning
        if (this.hasOptions) {
            if (firstGroup.length > 0 || sortingSelection.length > 0) {
                var firstGroupNode = sortingSelection.length > 0 ? sortingSelection.get()[0] : firstGroup.get()[0];
                if (mobileBackdrop !== undefined) {
                    firstGroupNode.parentNode.insertBefore(mobileBackdrop.get()[0], firstGroupNode);
                }
                if (showMobileButton !== undefined && !showMobileButton.isMounted()) {
                    firstGroupNode.parentNode.insertBefore(showMobileButton.get()[0], firstGroupNode);
                }
                if (filterLayer.parents("#".concat(this.context.layerId), true).length === 0) {
                    firstGroupNode.parentNode.insertBefore(filterLayer.get()[0], firstGroupNode);
                }
            }
            else {
                if (showMobileButton !== undefined && !showMobileButton.isMounted()) {
                    this.context.getExistingLayer().append(mobileBackdrop);
                }
                if (mobileBackdrop !== undefined) {
                    this.context.getExistingLayer().append(showMobileButton);
                }
                if (filterLayer.parents("#".concat(this.context.layerId), true).length === 0) {
                    this.context.getExistingLayer().append(filterLayer);
                }
            }
        }
    };
    Filter.prototype.mount = function () {
        var _this = this;
        var filters = this.filters;
        var filterLayer = this.filterLayer;
        filterLayer.addClass('ss360-filter--mounting');
        var position = this.position;
        var $layer = sxQuery("#".concat(this.context.filterLayerId));
        if (filters.length > 100) { // hide so it doesn't retrigger so many repaints
            $layer.hide();
        }
        filters.forEach(function (filter) {
            var filterWrap = filter.getWrapper();
            if (filterWrap.parents("#".concat(_this.context.filterLayerId), true).length === 0) {
                filterLayer.append(filterWrap);
            }
        });
        if (filters.length > 100) {
            $layer.show();
        }
        filters.forEach(function (filter) { return filter.mount(); });
        var layerContent = this.context.getExistingLayer().find('.ss360-layer__content');
        if (position === FilterPosition.Left) {
            layerContent.addClass('ss360-layer__content--filter-left ss360-flex ss360-flex--wrap');
            if (this.filterConfig.forceSlideIn) {
                layerContent.addClass('ss360-filter--slide');
            }
            var filteredResults = this.context.getExistingFilteredResultsLayer();
            if (filteredResults.length === 0) {
                filteredResults = sxQuery("<div id=\"".concat(this.context.filteredResultsId, "\" class=\"ss360-layer__filtered-results ss360-flex ss360-flex--column\"></div>"));
                layerContent.append(filteredResults);
            }
            filteredResults.append(sxQuery("#".concat(this.context.layerId, " .ss360-group, #").concat(this.context.noResultsLayerId)));
            filterLayer.addClass('ss360-flex--column ss360-flex--nowrap');
            filteredResults.prepend(this.context.getExistingSorting());
            filteredResults.prepend(sxQuery("#".concat(this.context.layerId, " .ss360-query-correction")));
            if (sxQuery("#".concat(this.context.layerId)).find('.ss360-related-queries--belowResultLayer').length > 0) {
                filteredResults.append(sxQuery("#".concat(this.context.layerId)).find('.ss360-related-queries--belowResultLayer'));
            }
        }
        else {
            layerContent.addClass('ss360-layer__content--filter-top');
            if (this.sortingSelection.length > 0) {
                var firstContentGroup = this.context.getExistingLayer().find('.ss360-group:first').get()[0];
                if (firstContentGroup !== undefined && firstContentGroup !== null && sxQuery(firstContentGroup.previousElementSibling).attr('id') !== 'ss360Sorting') {
                    firstContentGroup.parentNode.insertBefore(this.sortingSelection.get()[0], firstContentGroup);
                }
            }
        }
        setTimeout(function () {
            filterLayer.removeClass('ss360-filter--mounting');
        }, 300);
    };
    Filter.prototype.renderDeleteBar = function () {
        var _this = this;
        var filterConfig = this.filterConfig;
        var quickDeleteBar = this.context.getExistingLayer().find('.ss360-filter__delete-bar');
        quickDeleteBar.empty();
        if (filterConfig.showQuickDelete && (this.activeOptions.length > 0 || this.activeGuidedQuestions.length > 0)) {
            if (quickDeleteBar.length === 0) {
                quickDeleteBar = sxQuery('<section role="search" class="ss360-n-section ss360-filter__delete-bar ss360-flex ss360-flex--wrap ss360-flex--align-center"></section>');
                quickDeleteBar.attr('aria-label', this.filterConfig.selectedFilterOptionsLabel);
            }
            var deleteAllButton_1 = sxQuery("<button type=\"button\" aria-label=\"".concat(filterConfig.deleteAllLabel, "\" class=\"ss360-filter__delete-button \n\t\t\tss360-filter__delete-button--all ss360-flex ss360-flex--align-center ss360-n-button ss360-ac-b ss360-ac-bg\">").concat(filterConfig.deleteAllLabel, "</button>"));
            deleteAllButton_1.on('click', function () {
                _this.activeGuidedQuestions = [];
                quickDeleteBar.find('.ss360-filter__delete-button').fadeOut();
                Object.keys(_this.activeFilter).forEach(function (key) {
                    delete _this.activeFilter[key];
                });
                _this.changeHandler('0', undefined); // delete all filter
            });
            quickDeleteBar.append(deleteAllButton_1);
            var themeColor_1 = this.context.pluginConfiguration.style.themeColor;
            var createButton_1 = function (label, keyLabel, val) { return sxQuery("<button type=\"button\" aria-label=\"".concat(label, "\" class=\"ss360-flex ss360-flex--align-center ss360-filter__delete-button ss360-n-button ss360-tc-b ss360-tc-c\">\n\t\t\t").concat(keyLabel ? "<span class=\"ss360-filter__delete-button-key\">".concat(keyLabel, ": </span>") : '', "\n\t\t\t<span class=\"ss360-filter__delete-button-value\">").concat(val, "</span>\n\t\t\t<i class=\"ss360-filter__delete-button-icon\">").concat(Icons.getSvgIcon(Icons.CROSS, themeColor_1, 'ss360-filter__delete-button-svg'), "</i>\n\t\t\t<i class=\"ss360-filter__delete-button-icon ss360-filter__delete-button-icon--active\">").concat(Icons.getSvgIcon(Icons.FILLED_CROSS, themeColor_1, 'ss360-filter__delete-button-svg'), "</i>\n\t\t\t</button>")); };
            this.activeOptions.forEach(function (activeOption) {
                var afkey = Object.keys(activeOption)[0];
                var afname = _this.keyToName[afkey] || _this.fallbackNames[afkey];
                if (afname === undefined) { // the view name is not available (probably unselecting the option wouldn't influence the result set) --> ignore
                    return;
                }
                var afGroup = _this.filterGroups.filter(function (group) { return group.key === afkey; })[0];
                var configuredLabel = afGroup !== undefined ? _this.getSetting(afGroup).label : undefined;
                if (configuredLabel !== undefined) {
                    afname = configuredLabel;
                }
                var createDeleteButton = function (label, displayValue, dataValue, keyLabel) {
                    var val = StringHelper.escapeHtml("".concat(displayValue[0].toUpperCase()).concat(displayValue.substring(1)));
                    var btn = createButton_1(label, keyLabel, val);
                    if (dataValue === '~false') {
                        btn.find('.ss360-filter__delete-button-value').addClass('ss360-filter__delete-button-value--negative');
                    }
                    btn.on('click', function () {
                        btn.fadeOut();
                        if (dataValue === undefined || dataValue === '~true' || dataValue === '~false') {
                            if (Object.keys(_this.activeFilter).length === 1) {
                                deleteAllButton_1.fadeOut();
                            }
                            _this.changeHandler(afkey || afname, undefined); // remove range filter
                        }
                        else {
                            // @ts-ignore
                            var vcopy = __spreadArray([], _this.activeFilter[afkey], true);
                            if (Object.keys(_this.activeFilter).length === 1 && vcopy.length === 1) {
                                deleteAllButton_1.fadeOut();
                            }
                            if (_this.filterDeletionValueMap[afkey] !== undefined && _this.filterDeletionValueMap[afkey][dataValue] !== undefined) {
                                dataValue = _this.filterDeletionValueMap[afkey][dataValue];
                            }
                            if (vcopy.indexOf(dataValue) !== -1) {
                                vcopy.splice(vcopy.indexOf(dataValue), 1);
                            }
                            _this.changeHandler(afkey || afname, vcopy); // remove multiselect filter
                        }
                        if (quickDeleteBar.find('.ss360-filter__delete-button:not(.ss360-filter__delete-button--all)').length === 0) {
                            quickDeleteBar.remove();
                        }
                    });
                    return btn;
                };
                var activeOptionVal = activeOption[afkey];
                // @ts-ignore
                if (activeOptionVal.min !== undefined && !Helper.isNaN(parseFloat(activeOptionVal.min)) &&
                    // @ts-ignore
                    activeOptionVal.max !== undefined && !Helper.isNaN(parseFloat(activeOptionVal.max))) {
                    var tempObj = {
                        name: afname,
                        key: afkey
                    };
                    var unit = _this.getSetting(tempObj).unit;
                    if (unit === undefined) {
                        unit = _this.units[afkey];
                    }
                    if (unit === undefined) {
                        // @ts-ignore
                        unit = activeOptionVal.unit;
                    }
                    var afunit = unit !== undefined ? " ".concat(unit) : '';
                    // @ts-ignore
                    var minVal = activeOptionVal.min;
                    // @ts-ignore
                    var maxVal = activeOptionVal.max;
                    var afmin = minVal.toFixed(minVal === Math.round(minVal) ? 0 : 2);
                    var afmax = maxVal.toFixed(maxVal === Math.round(maxVal) ? 0 : 2);
                    if (afGroup !== undefined && afGroup.filterType === 'DATE') {
                        var factor = afGroup.precision === DatePrecision.MS ? 1 : 1000;
                        afmin = new Date(minVal * factor).toLocaleDateString(_this.filterConfig.dateFormatLocale);
                        afmax = new Date(maxVal * factor).toLocaleDateString(_this.filterConfig.dateFormatLocale);
                    }
                    else {
                        afmin += afunit;
                        afmax += afunit;
                    }
                    quickDeleteBar.append(createDeleteButton("Clear ".concat(afname, " filter"), "".concat(afmin, " - ").concat(afmax), undefined, 
                    // @ts-ignore
                    activeOptionVal.shortName));
                }
                else if (activeOptionVal instanceof Array) {
                    // @ts-ignore
                    activeOptionVal.forEach(function (afval) {
                        var displayName = afval;
                        var isTree = afGroup !== undefined && (afGroup.type === FilterType.CategoryTree || afGroup.type === FilterType.Tree);
                        if (afGroup !== undefined && (!_this.isSimpleValueFormat || isTree)) { // TODO: naming conventions
                            if (isTree) {
                                var stack_1 = JSON.parse(JSON.stringify(afGroup.categories));
                                while (stack_1.length > 0) {
                                    var item = stack_1.splice(0, 1)[0];
                                    if (item.conceptId !== undefined && item.conceptId.toString() === afval.toString()) {
                                        displayName = item.name;
                                        break;
                                    }
                                    (item.children || []).forEach(function (child) {
                                        stack_1.push(child);
                                    });
                                }
                            }
                            else {
                                // @ts-ignore
                                displayName = (afGroup.values.filter(function (val) { return val.key === afval; })[0] || {}).name || afval;
                            }
                        }
                        if (afGroup === undefined && _this.optionViewNames["".concat(afkey, "<#>").concat(displayName)] !== undefined) {
                            displayName = _this.optionViewNames["".concat(afkey, "<#>").concat(displayName)];
                        }
                        if (displayName !== undefined) {
                            quickDeleteBar.append(createDeleteButton("Clear ".concat(displayName, " filter option of ").concat(afname), displayName, afval));
                        }
                    });
                }
                else if (activeOptionVal === true || activeOptionVal === false) {
                    var displayName = afGroup !== undefined ? afGroup.name : undefined;
                    if (displayName !== undefined) {
                        quickDeleteBar.append(createDeleteButton("Clear ".concat(displayName, " filter option"), displayName, "~".concat(activeOptionVal)));
                    }
                }
            });
            this.activeGuidedQuestions.forEach(function (question) {
                if (question.name) {
                    var btn_1 = createButton_1('', '', question.name);
                    btn_1.addClass('ss360-filter__delete-button--guided-question');
                    quickDeleteBar.append(btn_1);
                    btn_1.on('click', function () {
                        btn_1.fadeOut();
                        if (quickDeleteBar.children().length === 2) {
                            deleteAllButton_1.fadeOut();
                        }
                        _this.onChange(_this.activeFilter, _this.activeGuidedQuestions.filter(function (q) { return q.questionId !== question.questionId; }));
                    });
                }
            });
            var wrpr = this.context.getExistingLayer().find('.ss360-layer__content').get()[0];
            var showMobileButton = this.position === FilterPosition.Left ? this.context.getExistingLayer().find('.ss360-filter__mobile-toggle') : undefined;
            var prevSibling = void 0;
            if (this.position === FilterPosition.Left) {
                prevSibling = showMobileButton !== undefined && showMobileButton.length > 0 ? showMobileButton.get()[0] : this.context.getExistingHeading().get()[0];
            }
            else {
                prevSibling = this.context.getExistingFilterLayer().get()[0];
            }
            if (prevSibling === undefined && this.position === FilterPosition.Top) {
                prevSibling = this.context.getExistingHeading().get()[0];
            }
            if (quickDeleteBar.find('.ss360-filter__delete-button:not(.ss360-filter__delete-button--all)').length === 0) {
                quickDeleteBar.remove();
            }
            else if (prevSibling !== undefined && prevSibling.nextElementSibling !== null && SxQueryUtils.indexInNodeList(prevSibling.nextElementSibling, wrpr.children) !== -1) {
                wrpr.insertBefore(quickDeleteBar.get()[0], prevSibling.nextElementSibling);
            }
            else {
                sxQuery(wrpr).append(quickDeleteBar);
            }
        }
    };
    Filter.prototype.bindMappings = function (filterMapping) {
        var _this = this;
        var groupCache = this.groupCache;
        var pluginConfig = this.context.pluginConfiguration;
        if (filterMapping !== undefined && Object.keys(filterMapping).length > 0 && pluginConfig.layout.navigation.type === 'tabs'
            && pluginConfig.layout.navigation.position !== 'none'
            && this.context.getExistingLayer().find('.ss360-group').length > 1) {
            var toggleFilterVisibility_1 = function (mapping) {
                if (mapping === void 0) { mapping = []; }
                var groupsByKey = groupCache.groupByKey || {};
                var visibleGroupCount = 0;
                Object.keys(groupsByKey).forEach(function (key, idx) {
                    var group = groupsByKey[key];
                    var wrapper = group.wrapper;
                    if (wrapper !== undefined) {
                        if (mapping.indexOf(key) !== -1) {
                            wrapper.show();
                            visibleGroupCount++;
                            if (_this.filters[idx] !== undefined && _this.position !== FilterPosition.Top) {
                                if (visibleGroupCount <= _this.filterConfig.expandedGroupsCount) {
                                    _this.filters[idx].show();
                                }
                            }
                        }
                        else {
                            wrapper.hide();
                        }
                    }
                });
                if (visibleGroupCount === 0) {
                    _this.context.getExistingLayer().find('.ss360-filter__mobile-toggle').hide();
                    _this.filterLayer.hide();
                }
                else {
                    _this.context.getExistingLayer().find('.ss360-filter__mobile-toggle').show();
                    _this.filterLayer.css('display', _this.position === FilterPosition.Top ? 'flex' : 'block');
                    (groupCache.filters || []).forEach(function (f) { return f.mount(); }); // e.g. to rerender the sliders
                }
            };
            this.context.subscribe('navigationChange', 'filterMappingHandler', function (openTab) {
                toggleFilterVisibility_1(openTab === pluginConfig.layout.navigation.allResultsTabName || openTab === '*' ? Object.keys(groupCache.groupByKey || {}) : filterMapping[openTab]);
            });
            var openTab = this.context.getExistingLayer().find('.ss360-nav__select').length > 0 ? this.context.getExistingLayer().find('.ss360-nav__select').val() : this.context.getExistingLayer().find('.ss360-nav__menu-item--active').data('cgkey');
            if (openTab === 'ss360_all_results') {
                toggleFilterVisibility_1(Object.keys(groupCache.groupByKey || {}));
            }
            else {
                var keys = Object.keys(filterMapping);
                var matchingFilters = void 0;
                for (var i = 0; i < keys.length; i++) {
                    var currentKey = keys[i];
                    if (openTab === StringHelper.getSafeKey(currentKey)) {
                        matchingFilters = filterMapping[currentKey];
                        break;
                    }
                }
                toggleFilterVisibility_1(matchingFilters);
            }
        }
    };
    return Filter;
}());
export default Filter;
